<template>
<div>

<div v-if="type">
      
      <h4>MISURE CAMPIONATE PER BRAND,CATEGORIA,REPARTO <strong>{{ sizeList.data }}</strong></h4>
      

  </div>
  <div v-else>
    <div class="spinner-grow spinner-grow-sm text-warning"   role="status">
        <span class="sr-only">Loading...</span>
    </div>
  </div>  


</div>
</template>

<script>
import { mapGetters }      from 'vuex';
import api from '@/api'

  export default {
    props:['props'],
    
    data () {
      return {
        
        cols         : [], 
        candidates   : [],
        spinner      : false,
        items        : [],
        sizeList     : {},
        type         : false

        
      }
    },
  
    computed: 
  {
    ...mapGetters(['company']) , 
  },

    created () 
    {
      //console.log(this.props.brand)
      this.getData()
    },

    methods: 
    {
            
      async getData()
      {
        this.type      = false
        this.sizeList  = {}
        this.spinner   = true
        const data     = {
        "companyId"    : this.company.Id,
        "brandId"      : this.props.brand,
        "categoryId"   : this.props.categoryId,
        "departmentId" : this.props.departmentId}
        

        const sp       = {'sp'        : 'spCustomSizeList'}
        const json     = Object.assign(data, sp)

        await api.post(json).then(res => {
          if(res.status==200)
            {
                //console.log(res.data.recordsets)
                if(res.data.recordsets[0].length > 0)
                { 
                    
                    this.sizeList.data =    res.data.recordsets[0][0].data
                    this.sizeList.Ids =    res.data.recordsets[0][0].Ids 
                    const sizes = res.data.recordsets[0][0].data.split('|')
                    const Ids   = res.data.recordsets[0][0].Ids.split('|')
                    //console.log('SIZES',res.data.recordsets[0][0].data)
                    let sizeList = []
                    for (let i = 0; i < sizes.length; i++) {
                      sizeList.push({'selected':1,'size':sizes[i],'sizeId':Ids[i],'newSize':'N','custom':1})     
                      //sizeList.push({'selected':1,'size':sizes[i],'sizeId':Ids[i]})     
                    }
                    //console.log(sizeList)
                    this.$emit('update',sizeList)

                }
            /*    
            this.cols = res.data.recordsets[0]
            
            this.selection.forEach(item=>{

              this.cols.forEach(col=>{
                if(item.sizeId == col.sizeId)
                {
                  col.selected = 1
                  this.candidates.push(item.sizeId)
                }
              })    
            })
            */         
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.type = true
        });
        
      },  

    }
  }
</script>
<style scoped>


  h4 {
  font-family : 'Roboto Condensed';
  font-size   : 16px;
}
strong{
  font-size   : 20px;
  color:darkgreen
}

</style>
